(() => {
  'use strict';

  if (window.FFFavorites) return;
  window.FFFavorites = true;

  const config = window.FF_CONFIG || {};
  const storageKey = config.key || 'ff-favorites-v1';
  const root = (config.root || '/').replace(/\/?$/, '/');
  const page = document.querySelector('[data-ff-page]');
  const products = new Map();
  const pending = new Set();
  const failed = new Set();
  let storageError = false;
  let undo = null;
  let sortOrder = 'newest';
  const comparisonStorageKey = storageKey + '-comparison';
let selected = [];

try {
  const savedSelection = JSON.parse(
    localStorage.getItem(comparisonStorageKey) || '[]'
  );

  if (Array.isArray(savedSelection)) {
    selected = [...new Set(
      savedSelection.filter(key => typeof key === 'string')
    )].slice(0, 3);
  }
} catch {
  selected = [];
}
  let view = 'favorites';
  const comparisonFields = ['素材', 'サイズ', '重さ', '販売期間', '仕様'];

  const recordId = record => record.handle + ':' + record.variant;

  const escapeHTML = value => String(value ?? '').replace(
    /[&<>"']/g,
    character => ({
      '&': '&amp;',
      '<': '&lt;',
      '>': '&gt;',
      '"': '&quot;',
      "'": '&#39;'
    })[character]
  );

  function readRecords() {
    try {
      const value = JSON.parse(localStorage.getItem(storageKey) || '[]');
      if (!Array.isArray(value)) throw new Error('Invalid data');

      const seen = new Set();

      const result = value.filter(record => {
        if (
          !record ||
          typeof record.handle !== 'string' ||
          !record.handle ||
          record.handle.length > 300 ||
          !/^\d+$/.test(String(record.variant))
        ) return false;

        const key = recordId(record);
        if (seen.has(key)) return false;
        seen.add(key);
        return true;
      }).slice(0, 100).map(record => ({
        handle: record.handle,
        variant: String(record.variant)
      }));

      storageError = false;
      return result;
    } catch {
      storageError = true;
      return null;
    }
  }

  let records = readRecords() || [];

  function saveRecords(next) {
    try {
      localStorage.setItem(storageKey, JSON.stringify(next));
      records = next;
      storageError = false;
      return true;
    } catch {
      storageError = true;
      return false;
    }
  }

  function makeURL(path) {
    const url = new URL(root + path, location.origin);
    if (config.preview) {
      url.searchParams.set('preview_theme_id', config.preview);
    }
    return url;
  }

  function favoritesURL() {
    return makeURL(config.pagePath || 'pages/favorites-compare').href;
  }

  function buttonRecord(button) {
    const form = button.dataset.form
      ? document.getElementById(button.dataset.form)
      : null;

    const variant = form?.querySelector('[name="id"]')?.value
      || button.dataset.variant;

    return {
      handle: button.dataset.handle,
      variant: String(variant || '')
    };
  }

  function updateButtons() {
        // ヘッダーのお気に入り件数（PC・スマホ）
    const favoritePath = new URL(favoritesURL()).pathname;

    document.querySelectorAll(
      '.header .sp_wishlist > a, .header .header__right a.header__icon'
    ).forEach(link => {
      if (new URL(link.href, location.origin).pathname !== favoritePath) return;

      link.classList.add('ff-header-favorite');

      let badge = link.querySelector('.ff-header-favorite-count');

      if (!badge) {
        badge = document.createElement('span');
        badge.className = 'ff-header-favorite-count';
        badge.setAttribute('aria-hidden', 'true');
        link.appendChild(badge);
      }

      const count = records.length;
      const text = count > 99 ? '99+' : String(count);

      if (badge.textContent !== text) {
        badge.textContent = text;
      }

      badge.hidden = count === 0;
      link.setAttribute('aria-label', `お気に入り ${count}件`);
    });
    document.querySelectorAll('[data-ff-save]').forEach(button => {
      const current = buttonRecord(button);
      const saved = records.some(record =>
        recordId(record) === recordId(current)
      );

      const label = saved
        ? '✓ 追加済み｜お気に入りを見る'
        : '♡ お気に入りに追加';

      if (button.textContent.trim() !== label) {
        button.textContent = label;
      }
      button.classList.toggle('ff-saved', saved);
    });
  }

  function announce(message) {
    if (page) {
      page.querySelector('[data-ff-status]').textContent = message;
    }
  }

  function productLink(record) {
    const url = makeURL('products/' + encodeURIComponent(record.handle));
    url.searchParams.set('variant', record.variant);
    return escapeHTML(url.href);
  }

  function sortedRecords() {
    const sorted = [...records].reverse();
    if (sortOrder === 'newest') return sorted;
    return sorted.sort((a, b) => {
      const priceA = products.get(recordId(a))?.priceValue;
      const priceB = products.get(recordId(b))?.priceValue;
      const validA = Number.isFinite(priceA);
      const validB = Number.isFinite(priceB);
      if (!validA && !validB) return 0;
      if (!validA) return 1;
      if (!validB) return -1;
      return sortOrder === 'price-asc' ? priceA - priceB : priceB - priceA;
    });
  }

  function comparisonPicture(product) {
    return product.image
      ? `<img src="${escapeHTML(product.image)}" alt="${escapeHTML(product.title)}" width="320" height="320" loading="lazy">`
      : '<span>画像なし</span>';
  }

  function renderComparison() {
    const host = page.querySelector('[data-ff-comparison]');
    if (!host) return;
    selected = selected.filter(key => records.some(record => recordId(record) === key));
    if (!storageError) {
  try {
    localStorage.setItem(
      comparisonStorageKey,
      JSON.stringify(selected)
    );
  } catch {
    // 保存できない環境でも、比較機能はそのまま使えます。
  }
}
    page.querySelectorAll('[data-ff-tab]').forEach(button => {
      const active = button.dataset.ffTab === view;
      button.setAttribute('aria-selected', String(active));
      button.tabIndex = active ? 0 : -1;
    });
    page.querySelector('#ff-panel-favorites').hidden = view !== 'favorites';
    page.querySelector('#ff-panel-compare').hidden = view !== 'compare';
    page.querySelector('[data-ff-compare-count]').textContent = selected.length;
    page.querySelector('[data-ff-selection]').textContent = `${selected.length}点を選択中（最大3点）`;
    page.querySelector('[data-ff-tray]').hidden = records.length === 0;
    page.querySelector('[data-ff-go]').disabled = selected.length < 2;
    page.querySelectorAll('[data-ff-clear-comparison]').forEach(button => {
      button.disabled = selected.length === 0;
    });
    if (selected.length < 2) {
      host.innerHTML = '<div class="ff-empty"><p>お気に入りから2〜3点を選んでください。</p><button type="button" class="ff-secondary" data-ff-back>お気に入りへ戻る</button></div>';
      return;
    }
    const chosen = selected.map(key => records.find(record => recordId(record) === key));
    if (selected.some(key => !products.has(key))) {
      host.innerHTML = `<p>${selected.some(key => failed.has(key))
        ? '商品情報を読み込めませんでした。お気に入りに戻り「再読み込み」を押してください。'
        : '比較する商品を読み込み中…'}</p>`;
      return;
    }
    const rows = [
      ['メーカー', product => product.vendor],
      ['価格', product => product.price],
      ...comparisonFields.map(field => [field, product => product.fields?.[field]])
    ];
    host.innerHTML = `
      <p class="ff-comparison-swipe-hint">← 左右にスワイプして比較 →</p>
      <div class="ff-table-scroll" role="region" aria-label="ランドセル比較表。横にスクロールできます" tabindex="0">
        <table>
          <caption>選んだランドセルの比較</caption>
          <thead><tr><th scope="col">商品</th>${chosen.map(record => {
            const product = products.get(recordId(record));
            return `<th scope="col">
              <button type="button" class="ff-remove" data-ff-uncompare="${escapeHTML(recordId(record))}" aria-label="${escapeHTML(product.title)}を比較から外す">× 比較から外す</button>
              <div class="ff-image">${comparisonPicture(product)}</div>
              <h2>${escapeHTML(product.title)}</h2>
              <a class="ff-product-link" href="${productLink(record)}">商品ページを見る →</a>
            </th>`;
          }).join('')}</tr></thead>
          <tbody>${rows.filter(([, value]) => chosen.some(record => String(value(products.get(recordId(record))) ?? '').trim())).map(([label, value]) => `
            <tr><th scope="row">${escapeHTML(label)}</th>${chosen.map(record => `<td>${escapeHTML(value(products.get(recordId(record))) || '')}</td>`).join('')}</tr>
          `).join('')}</tbody>
        </table>
      </div>
      <p class="ff-comparison-note">商品情報（素材・サイズ・重さ・販売期間・仕様など）は順次追加しています。掲載されていない情報については、商品ページをご確認いただくか、お気軽にお問い合わせください。</p>`;
  }

  function switchView(next) {
    view = next;
    render();
    page.querySelector(`[data-ff-tab="${view}"]`)?.focus();
  }

  function fieldText(element) {
    if (!element) return '';
    const copy = element.cloneNode(true);
    copy.querySelectorAll('script, style').forEach(node => node.remove());
    copy.querySelectorAll('br').forEach(node => {
  const next = node.nextSibling;

  if (next && next.nodeType === 3) {
    next.textContent = next.textContent.replace(/^[ \t]*\r?\n/, '');
  }

  node.replaceWith('\n');
});
    copy.querySelectorAll('p, li, div').forEach(node => node.append('\n'));
    return copy.textContent.replace(/\u00a0/g, ' ').replace(/\n[ \t]+/g, '\n').replace(/\n{3,}/g, '\n\n').trim();
  }

  function render() {
    updateButtons();
    if (!page) return;

    page.querySelector('[data-ff-count]').textContent = records.length;
    page.querySelector('[data-ff-toolbar]').hidden = records.length === 0;

    page.querySelector('[data-ff-grid]').innerHTML = records.length
      ? sortedRecords().map(record => {
          const key = recordId(record);
          const product = products.get(key);
          const removeButton = `
            <button type="button" class="ff-remove"
              data-ff-remove="${escapeHTML(key)}"
              aria-label="${escapeHTML(product?.title || 'この商品')}をお気に入りから外す">
              × お気に入りから外す
            </button>`;

          if (!product) {
            return `
              <article class="ff-card">
                ${removeButton}
                <div class="ff-pending">
                  ${failed.has(key)
                    ? '商品情報を読み込めませんでした。'
                    : '商品情報を読み込み中…'}
                </div>
                ${failed.has(key) ? `
                  <button type="button" class="ff-secondary"
                    data-ff-retry="${escapeHTML(key)}">
                    再読み込み
                  </button>` : ''}
              </article>`;
          }

          return `
            <article class="ff-card">
              ${removeButton}
              <div class="ff-image">
                ${product.image ? `
                  <img src="${escapeHTML(product.image)}"
                    alt="${escapeHTML(product.title)}"
                    width="320" height="320" loading="lazy">
                ` : '<span>画像なし</span>'}
              </div>
              <p class="ff-vendor">${escapeHTML(product.vendor)}</p>
              <h2>${escapeHTML(product.title)}</h2>
              <div class="ff-price">${escapeHTML(product.price)}</div>
              ${!product.available
              ? '<p class="ff-stock">売り切れ</p>'
              : product.stockLabel
                ? `<p class="ff-stock ff-stock--low">${escapeHTML(product.stockLabel)}</p>`
                : ''}
              <a class="ff-product-link" href="${productLink(record)}">
                商品ページを見る →
              </a>
              <label class="ff-select">
                <input type="checkbox" data-ff-select="${escapeHTML(key)}" ${selected.includes(key) ? 'checked' : ''}>
                <span>${selected.includes(key) ? '比較に選択中' : '比較する'}</span>
              </label>
            </article>`;
        }).join('')
      : `
        <div class="ff-empty">
          <h2>お気に入りはまだありません</h2>
          <p>気になるランドセルを、お気に入りに追加してみましょう。</p>
          <a class="ff-primary"
            href="${escapeHTML(makeURL('collections/school-bag').href)}">
            ランドセル一覧を見る →
          </a>
        </div>`;

    renderComparison();

    if (storageError) {
      announce('ブラウザの保存設定や空き容量をご確認ください。');
    }
  }

  async function loadProduct(record) {
    const key = recordId(record);
    if (products.has(key) || pending.has(key)) return;

    pending.add(key);
    failed.delete(key);

    const controller = new AbortController();
    const timer = setTimeout(() => controller.abort(), 15000);

    try {
      const url = makeURL('products/' + encodeURIComponent(record.handle));
      url.searchParams.set('variant', record.variant);
      url.searchParams.set('section_id', 'ff-product-data');

      const response = await fetch(url, {
        credentials: 'same-origin',
        signal: controller.signal
      });

      if (!response.ok) throw new Error('Request failed');

      const html = await response.text();
      const doc = new DOMParser().parseFromString(html, 'text/html');
      const node = doc.querySelector('[data-ff-product]');

      if (!node || node.dataset.variant !== record.variant) {
        throw new Error('Product unavailable');
      }

      let image = '';
      if (node.dataset.image) {
        const imageURL = new URL(node.dataset.image, location.origin);
        if (['https:', 'http:'].includes(imageURL.protocol)) {
          image = imageURL.href;
        }
      }

      const fields = {};
      comparisonFields.forEach(field => {
        fields[field] = fieldText(node.querySelector(`[data-field="${field}"]`));
      });
      products.set(key, {
        fields,
        title: node.dataset.title,
        vendor: node.dataset.vendor,
        price: node.dataset.price,
        priceValue: Number.parseFloat(node.dataset.priceValue),
        available: node.dataset.available === 'true',
        stockLabel: node.dataset.stockLabel || '',
        image
      });
    } catch {
      failed.add(key);
    } finally {
      clearTimeout(timer);
      pending.delete(key);
      render();
    }
  }

  async function loadProducts() {
    const queue = records.filter(record =>
      !products.has(recordId(record)) && !pending.has(recordId(record))
    );

    await Promise.all(
      Array.from({ length: Math.min(4, queue.length) }, async () => {
        while (queue.length) {
          await loadProduct(queue.shift());
        }
      })
    );
  }

  document.addEventListener('click', event => {
    if (!(event.target instanceof Element)) return;

    const addButton = event.target.closest('[data-ff-save]');

    if (addButton) {
      event.preventDefault();

      const message = addButton.closest('.ff-save-wrap')
        ?.querySelector('.ff-save-message');
      const latest = readRecords();

      if (latest === null) {
        if (message) message.textContent = 'ブラウザに保存できません。保存設定をご確認ください。';
        return;
      }

      records = latest;
      const record = buttonRecord(addButton);

      if (!record.handle || !/^\d+$/.test(record.variant)) {
        if (message) message.textContent = '商品を選び直してからお試しください。';
        return;
      }

      if (records.some(item => recordId(item) === recordId(record))) {
        location.href = favoritesURL();
        return;
      }

      if (records.length >= 100) {
        if (message) message.textContent = '保存は100点までです。お気に入り一覧で整理してください。';
        return;
      }

      if (!saveRecords([...records, record])) {
        if (message) message.textContent = '保存できません。ブラウザの保存設定をご確認ください。';
        return;
      }

      if (message) message.textContent = 'お気に入りに追加しました。';
      render();
      if (page) loadProducts();
      return;
    }

    if (!page || !page.contains(event.target)) return;

    const button = event.target.closest('button');
    if (!button) return;

    if (button.hasAttribute('data-ff-tab')) {
      switchView(button.dataset.ffTab);
      return;
    }
    if (button.hasAttribute('data-ff-go')) {
      if (selected.length >= 2) switchView('compare');
      return;
    }
    if (button.hasAttribute('data-ff-back')) {
      switchView('favorites');
      return;
    }
    if (button.hasAttribute('data-ff-clear-comparison')) {
      selected = [];
      if (undo) undo.selected = false;
      render();
      announce('比較の選択を解除しました。お気に入りには残っています。');
      page.querySelector(`[data-ff-tab="${view}"]`)?.focus();
      return;
    }
    if (button.hasAttribute('data-ff-uncompare')) {
      selected = selected.filter(key => key !== button.dataset.ffUncompare);
      render();
      announce('比較から外しました。お気に入りには残っています。');
      page.querySelector('[data-ff-tab="compare"]')?.focus();
      return;
    }

    if (button.hasAttribute('data-ff-remove')) {
      const latest = readRecords();
      if (latest === null) {
        announce('保存状態を確認できないため、削除しませんでした。');
        return;
      }
      records = latest;

      const key = button.dataset.ffRemove;
      const index = records.findIndex(record => recordId(record) === key);
      if (index < 0) {
        render();
        return;
      }

      const removed = records[index];

      if (!saveRecords(records.filter(record => recordId(record) !== key))) {
        announce('保存できないため、削除しませんでした。');
        return;
      }

      undo = { record: removed, index, selected: selected.includes(key) };
      selected = selected.filter(item => item !== key);
      render();
      announce('お気に入りから外しました。 ');

      const restore = document.createElement('button');
      restore.type = 'button';
      restore.className = 'ff-secondary';
      restore.dataset.ffUndo = '';
      restore.textContent = '元に戻す';
      page.querySelector('[data-ff-status]').append(restore);
      restore.focus();
    } else if (button.hasAttribute('data-ff-undo') && undo) {
      const latest = readRecords();
      if (latest === null) {
        announce('保存状態を確認できませんでした。');
        return;
      }

      if (!latest.some(record =>
        recordId(record) === recordId(undo.record)
      )) {
        if (latest.length >= 100) {
          announce('保存は100点までです。');
          return;
        }
        latest.splice(Math.min(undo.index, latest.length), 0, undo.record);
      }

      if (!saveRecords(latest)) {
        announce('保存できませんでした。');
        return;
      }

      if (undo.selected && selected.length < 3 && !selected.includes(recordId(undo.record))) selected.push(recordId(undo.record));
      undo = null;
      render();
      announce('お気に入りに戻しました。');
      loadProducts();
    } else if (button.hasAttribute('data-ff-retry')) {
      const record = records.find(item =>
        recordId(item) === button.dataset.ffRetry
      );
      if (record) {
        loadProduct(record);
        render();
      }
    }
  });

  document.addEventListener('change', event => {
    const input = event.target;
    if (!page || !(input instanceof HTMLInputElement) || !page.contains(input) || !input.matches('[data-ff-select]')) return;
    const key = input.dataset.ffSelect;
    if (!records.some(record => recordId(record) === key)) return;
    if (input.checked && !selected.includes(key)) {
      if (selected.length >= 3) {
        input.checked = false;
        announce('比較は3点までです。先に1点外してください。');
        return;
      }
      selected.push(key);
    } else if (!input.checked) {
      selected = selected.filter(item => item !== key);
    }
    input.closest('label').querySelector('span').textContent = input.checked ? '比較に選択中' : '比較する';
    renderComparison();
  });

  document.addEventListener('keydown', event => {
    if (!page || !(event.target instanceof Element) || !page.contains(event.target)) return;
    const tab = event.target.closest('[data-ff-tab]');
    if (!tab || !['ArrowLeft', 'ArrowRight', 'Home', 'End'].includes(event.key)) return;
    event.preventDefault();
    switchView(event.key === 'Home' ? 'favorites' : event.key === 'End' ? 'compare' : view === 'favorites' ? 'compare' : 'favorites');
  });

  document.addEventListener('change', updateButtons);
  document.addEventListener('change', event => {
    if (!page || !(event.target instanceof HTMLSelectElement)) return;
    if (!page.contains(event.target) || !event.target.matches('[data-ff-sort]')) return;
    const value = event.target.value;
    if (!['newest', 'price-asc', 'price-desc'].includes(value)) return;
    sortOrder = value;
    render();
  });

  document.addEventListener('shopify:section:load', updateButtons);

  window.addEventListener('storage', event => {
    if (event.key !== storageKey && event.key !== null) return;
    const latest = readRecords();
    if (latest !== null) records = latest;
    render();
    if (page) loadProducts();
  });

  new MutationObserver(updateButtons).observe(document.body, {
    childList: true,
    subtree: true
  });

  render();
  if (page) loadProducts();
})();

/* FF comparison design 20261029 START */
(() => {
  'use strict';
  if (window.FFComparisonDesign20261029) return;
  window.FFComparisonDesign20261029 = true;

  function init() {
    const page = document.querySelector('[data-ff-page]');
    const host = page?.querySelector('[data-ff-comparison]');
    if (!host) return;
    let expanded = false;
    let frame = 0;
    let id = 0;

    function update() {
      frame = 0;
      const table = host.querySelector('.ff-table-scroll table');
      if (!table || table.getBoundingClientRect().width === 0) return;

      // 商品名が複数行でも、各商品のリンク位置をそろえる。
      const titles = [...table.querySelectorAll('thead h2')];
      titles.forEach(title => { title.style.minHeight = '0px'; });
      const titleHeight = Math.max(0, ...titles.map(title => title.getBoundingClientRect().height));
      titles.forEach(title => { title.style.minHeight = `${Math.ceil(titleHeight)}px`; });

      const rows = [...table.querySelectorAll('tbody tr')];
      const priceRow = rows.find(row => row.querySelector('th')?.textContent.trim() === '価格');
      priceRow?.querySelectorAll('td').forEach(cell => {
        cell.style.fontSize = '13px';
        cell.style.fontWeight = '400';
      });
      const specRow = rows.find(row => row.querySelector('th')?.textContent.trim() === '仕様');
      if (!specRow) return;

      specRow.querySelectorAll('td').forEach(cell => {
        if (!cell.textContent.trim()) return;
        let content = cell.querySelector('.ff-spec-content');
        if (!content) {
          content = document.createElement('div');
          content.className = 'ff-spec-content';
          content.id = `ff-comparison-spec-${++id}`;
          while (cell.firstChild) content.appendChild(cell.firstChild);
          cell.appendChild(content);
        }
        content.dataset.collapsed = String(!expanded);
        const isLong = content.scrollHeight > 157;
        let button = cell.querySelector('.ff-spec-toggle');
        if (isLong && !button) {
          button = document.createElement('button');
          button.type = 'button';
          button.className = 'ff-spec-toggle';
          button.setAttribute('aria-controls', content.id);
          cell.appendChild(button);
        }
        if (button) {
          button.hidden = !isLong;
          button.setAttribute('aria-expanded', String(expanded));
          button.textContent = expanded ? 'すべての仕様を閉じる −' : 'すべての仕様をもっと見る ＋';
        }
      });
      const controls = [...specRow.querySelectorAll('.ff-spec-content')].map(content => content.id).join(' ');
      specRow.querySelectorAll('.ff-spec-toggle').forEach(button => button.setAttribute('aria-controls', controls));
    }

    function schedule() {
      if (!frame) frame = requestAnimationFrame(update);
    }
    host.addEventListener('click', event => {
      const button = event.target.closest?.('.ff-spec-toggle');
      if (!button || !host.contains(button)) return;
      expanded = !expanded;
      update();
    });
    // 商品選択・並べ替えなどによる既存コードの再描画に追従する。
    new MutationObserver(schedule).observe(host, { childList: true });
    const panel = host.closest('[role="tabpanel"]');
    if (panel) new MutationObserver(schedule).observe(panel, {
      attributes: true,
      attributeFilter: ['hidden']
    });
    window.addEventListener('resize', schedule);
    document.fonts?.ready.then(schedule);
    schedule();
  }
  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init, { once: true });
  } else {
    init();
  }
})();
/* FF comparison design 20261029 END */

/* FF comparison sticky names 20261029 START */
(() => {
  'use strict';
  if (window.FFComparisonStickyNames20261029) return;
  window.FFComparisonStickyNames20261029 = true;

  function ffStickyGeometry(table, head, box, viewportWidth, top, height) {
    const left = Math.max(0, box.left);
    const right = Math.min(viewportWidth, box.right);
    return {
      visible: right > left && head.bottom <= top && table.bottom > top + height,
      left,
      width: Math.max(0, right - left),
      shift: table.left - left
    };
  }

  function init() {
    const page = document.querySelector('[data-ff-page]');
    const host = page?.querySelector('[data-ff-comparison]');
    if (!host) return;
    const bar = document.createElement('div');
    bar.className = 'ff-comparison-floating-names';
    bar.setAttribute('aria-hidden', 'true');
    bar.hidden = true;
    const track = document.createElement('div');
    track.className = 'ff-comparison-floating-track';
    bar.append(track);
    document.body.append(bar);
    let table = null;
    let cells = [];
    let frame = 0;
    let followUntil = 0;
    const resize = new ResizeObserver(schedule);

    function schedule() {
      if (!frame) frame = requestAnimationFrame(update);
    }
    function followHeader() {
      followUntil = performance.now() + 500;
      schedule();
    }
    function update() {
      frame = 0;
      const next = host.querySelector('.ff-table-scroll table');
      if (next !== table) {
        resize.disconnect();
        table = next;
        track.replaceChildren();
        cells = table ? [...table.querySelectorAll('thead tr:first-child > th, thead tr:first-child > td')] : [];
        cells.forEach((cell, index) => {
          const item = document.createElement('div');
          item.className = 'ff-comparison-floating-cell';
          if (index === 0) {
            item.classList.add('ff-comparison-floating-label');
            item.textContent = '商品';
          } else {
            const original = cell.querySelector('.ff-image img');
            if (original) {
              const image = document.createElement('img');
              image.src = original.currentSrc || original.src;
              image.alt = '';
              item.append(image);
            }
            const name = document.createElement('span');
            name.textContent = cell.querySelector('h2')?.textContent.trim() || '';
            item.append(name);
          }
          track.append(item);
        });
        if (table) resize.observe(table);
      }
      if (!table || !table.getClientRects().length || cells.length < 3) {
        bar.hidden = true;
        return;
      }
      const head = table.querySelector('thead');
      const scroller = table.closest('.ff-table-scroll');
      const header = document.querySelector('.shopify-section-header');
      const headerRect = header?.getBoundingClientRect();
      const top = headerRect && headerRect.top <= 1 && headerRect.bottom > 0
        ? headerRect.bottom : 0;
      const tableRect = table.getBoundingClientRect();
      const box = scroller.getBoundingClientRect();
      const viewportWidth = document.documentElement.clientWidth;
      const measured = cells.map(cell => cell.getBoundingClientRect().width);
      track.style.width = tableRect.width + 'px';
      [...track.children].forEach((item, index) => {
        item.style.width = measured[index] + 'px';
      });
      // Measure while invisible, so the full names fit without truncation.
      bar.style.visibility = 'hidden';
      bar.hidden = false;
      const geometry = ffStickyGeometry(tableRect, head.getBoundingClientRect(), box, viewportWidth, top, bar.getBoundingClientRect().height);
      bar.style.left = geometry.left + 'px';
      bar.style.top = top + 'px';
      bar.style.width = geometry.width + 'px';
      track.style.transform = `translateX(${geometry.shift}px)`;
      bar.hidden = !geometry.visible;
      bar.style.visibility = '';
      if (performance.now() < followUntil) schedule();
    }
    new MutationObserver(schedule).observe(host, { childList: true });
    const panel = host.closest('[role="tabpanel"]');
    if (panel) new MutationObserver(schedule).observe(panel, {
      attributes: true, attributeFilter: ['hidden']
    });
    // Capturing also catches horizontal scrolling inside the comparison table.
    document.addEventListener('scroll', followHeader, { capture: true, passive: true });
    window.addEventListener('resize', followHeader, { passive: true });
    window.addEventListener('pageshow', followHeader);
    document.fonts?.ready.then(schedule);
    schedule();
  }
  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init, { once: true });
  } else {
    init();
  }
})();
/* FF comparison sticky names 20261029 END */
